module.exports = __webpack_public_path__ + "static/media/information_Patient_2.0.7b010813.pdf";